/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'fine',
    quality: 0.4,
    learning: 1,
	perception: 3
}